<template>
  <div class="header">
    <div class="header-nav">
        <nav class="navbar navbar-default">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header">
              <button type="button" class="navbar-toggle" v-bind:class="{ collapsed: !navBar }"  v-on:click='navBar = !navBar' data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <!-- <a class="navbar-brand" href="https://w3layouts.com/quickly-a-blogging-category-flat-bootstrap-responsive-web-template/"><span>Q</span>uickly</a> -->
              <router-link class="navbar-brand"
                :to="{ name: 'home' }">
              Group Blogger   
              </router-link>
          </div>
          <!-- style="height: 1px" -->
          <div class="navbar-collapse nav-wil"  v-bind:class="[{ collapse: !navBar }, 'collapse-in']" id="bs-example-navbar-collapse-1" >
            <ul class="nav navbar-nav">
              <!-- <router-link class="navbar-brand"
                :to="{ name: 'home' }">
                Group Blogger
              </router-link> -->
              <li class="hvr-bounce-to-bottom" active-class="active"><router-link class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'home' }">
                    Home
                  </router-link>
              </li>
              <li class="hvr-bounce-to-bottom"><router-link class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'about' }">
                    About
                  </router-link>
              </li>
              <li class="hvr-bounce-to-bottom"><router-link class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'portfolio' }">
                    Portfolio
                  </router-link>
              </li>
              <li class="hvr-bounce-to-bottom" v-bind:class="{ show: uMenuIsOpen }" v-on:click='uMenuIsOpen = !uMenuIsOpen' v-if="isAuthenticated">
                   <a class="nav-link dropdown-toggle" target="_self" id='navbarDropdownMenuLink' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                           User Dropdown
                                    </a>                 
                                    
              <div class="dropdown-menu" v-bind:class="{ show: uMenuIsOpen }" aria-labelledby="navbarDropdownMenuLink">
                  <ul>
                    <li  v-if="checkGroupRole(currentUser.usergroups,mainGroupId,writerRoles)" class="hvr-bounce-to-bottom">
                      <router-link class="nav-link"
                        active-class="active"
                        :to="{ name: 'article-edit' }">
                        <i class="ion-compose"></i>&nbsp;New Article
                        <!-- TODO: -->
                      </router-link>
                    </li>
                    <li class="hvr-bounce-to-bottom">
                      <router-link class="nav-link"
                        active-class="active"
                        exact
                        :to="{ name: 'settings' }">
                        <i class="ion-gear-a"></i>&nbsp;Settings
                      </router-link>
                    </li>
                      <!-- <li ng-repeat="subitem in menuitem.subtree | orderBy:'weight' track by $index " class="hvr-bounce-to-bottom" ui-sref-active="active">
                          <a ui-sref="{{subitem.link.description.state}}">{{subitem.link.title}}</a>
                      </li> -->
                      <!-- <li class="hvr-bounce-to-bottom" ui-sref-active="active"><a ui-sref="q.page({pageTitle: 'WeddingPage'})">Wedding Page</a></li> -->
                  </ul>
              </div>
              </li>
            </ul>
            <!-- end main header view -->
            <div class="sign-in" v-if="!isAuthenticated">
              <ul>
                <li class="nav-item">
                  <router-link class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'login' }">
                    <i class="ion-compose"></i>Sign in
                  </router-link> /
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'register' }">
                    <i class="ion-compose"></i>Sign up
                  </router-link>
                </li>
                <!-- <li><a ui-sref="auth.register">Register</a></li> -->
              </ul>
            </div>
              <!-- <ul v-if="!isAuthenticated" class="nav navbar-nav pull-xs-right">
              </ul> -->
            <div class="sign-in" v-else>
              <ul>
                <li class="nav-item" v-if="currentUser.username">
                  <router-link class="nav-link"
                    active-class="active"
                    exact
                    :to="{ name: 'profile', params: { username: currentUser.username } }">
                    {{ currentUser.username }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mainGroupId } from "@/common/config";

export default {
  name: "RwvHeader",
  data() {
    return {
      uMenuIsOpen: false,
      navBar: false,
      writerRoles: ["author", "admin"],
      mainGroupId
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  methods: {
    /**
     * check for valid role for group
     */
    checkGroupRole: function(usergroups, groupid, roleNames) {
      if (usergroups) {
        var groupIndex = usergroups.findIndex(x => x.group_id === groupid);
        if (groupIndex !== -1) {
          var usergroup = usergroups[groupIndex];
          return (
            usergroup.roles.findIndex(x => roleNames.indexOf(x.name) !== 1) !==
            1
          );
        }
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TheHeader.vue